import { config } from './domainConfig';

export const radioToggleValue = config.product === 'playnixzone' ? ['video', 'movie'] : ['movie', 'video', 'games'];
